import { Container, HeaderTitle, SubmitButton, InputForm, Left, Right } from "./style";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import { FormDataSource } from "../../util/formDataSource";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link, useLocation } from "react-router-dom";

import { useAppLocation } from "../../hooks/useAppLocation";
import { addProduct, getProduct, updateProduct } from '../../api/productsService';
import { getCategorys } from "../../api/categorysService";
import { getOrder, approveOrder, deleteOrder, updateOrderMessage } from "../../api/ordersService";
import { formProductInput } from "./ordersForm";
import { toast } from 'react-toastify';
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { productsColumns } from "./ordersForm";

import {
  ActionContainer,
  DataGridContainer,
  DataGridWrapper,
  OrderInfoContainer,
  OrderInfoItem,
  OrderInfoLabel,
  OrderStatusBadge,
  OrderInfoValue,
  OrderInfoValueBadge,
  OrderStatusContainer,
  OrderActionsContainer,
  ApproveButton,
  DeleteButton,
  OrderMessageContainer,
  OrderMessageLabel,
  OrderMessageTextArea,
  OrderMessageActions,
  SaveMessageButton,
} from "./style";

interface Props {
  Inputs?: FormDataSource[];
  actionMode?: string;
}
export type IUploadStatus = "NO_IMAGE" | "UPLOADING" | "UPLOADED";

const NewProduct: React.FC<Props> = ({ Inputs = formProductInput, actionMode = 'view' }) => {
  const { id }: any = useParams();

  // const [events, setEvents]: any = useState([]);
  const [options, setOptions]: any = useState({
    category: []
  });

  // states
  const [file, setFile] = useState<File | null>(null);
  // upload status for disabling submit button
  const [data, setData]: any = useState({
    orderItems: [],
    timestamp: new Date(),
    logo: `uploads/images/noimage.png`,
  });
  const [uploadStatus, setUploadStatus] = useState<IUploadStatus>("NO_IMAGE");

  const actions: GridColDef[] = [
    {
      field: "action",
      headerName: "Action",
      width: 160,
      renderCell: (params) => {
        return (
          <ActionContainer>
            <Link
              to={`/products/${params.row.id}`}
              state={{ ...params.row }}
              style={{ textDecoration: "none" }}
            >
              <button className="btn viewBtn">View</button>
            </Link>
            {/* <button
                onClick={() => handleDelete(params.row.id)}
                className="btn deleteBtn"
              >
                Delete
              </button> */}
          </ActionContainer>
        );
      },
    },
  ];
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categories = await getCategorys();
        setOptions((prev: any) => ({ ...prev, category_id_options: categories }));
        setData((prev: any) => ({
          ...prev,
          category_id: categories.length > 0 ? categories[0].id : "",
        }));
      } catch (error: any) {
        console.error("Error fetching categories:", error.message);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    if (actionMode === "view" && id) {
      const fetchOrderDetails = async () => {
        try {
          const order = await getOrder(id);
          if (order) {
            setData((prev: any) => ({
              ...prev,
              ...order,
              orderItems: order.order_items.map((item: any) => ({
                ...item.product,
                price: item.price,
                quantity: item.quantity,
                updated_at: item.updated_at,
              })),
            }));
          }
        } catch (error: any) {
          console.error("Error fetching order:", error.message);
        }
      };

      fetchOrderDetails();
    }
  }, [id, actionMode]);

  // useEffect(() => {

  //   getCategorys()
  //     .then((categorys: any) => {
  //       setOptions({ ...options, category_id_options: categorys });
  //       setData({
  //         ...data,
  //         category_id: categorys.length > 0 ? categorys[0].id : ''
  //       });
  //     })
  //     .catch((err: any) => console.log(err.message));
  // }, []);

  // useEffect(() => {
  //   if (actionMode == 'view') {
  //     getOrder(id).then((order) => {
  //       setData({
  //         ...order,
  //         orderItems: order?.order_items.map((item: any) => ({
  //           ...item.product,
  //           price: item.price,
  //           quantity: item.quantity,
  //           updated_at: item.updated_at
  //         }))
  //       });
  //     }).catch((err) => {
  //       console.log('error', err.message);
  //     })
  //   }
  // }, [id, actionMode]);

  useEffect(() => {
    if (file) {
      setData({
        ...data,
        image: file.name,
        file: file
      });
      setUploadStatus("UPLOADED");
    }
  }, [file]);

  // handle form submiting
  const handleSubmit = async (e: React.FormEvent<HTMLElement>) => {
    e.preventDefault();
    // Destructure required fields from the data object
    const isFormValid = Inputs.every((input) => {
      const value = data[input.id];
      return value !== undefined && value !== ""; // Ensure value is not empty or undefined
    });

    // Validate required fields
    if (
      !isFormValid
    ) {
      console.log('All fields are required.');
      toast.error('All fields are required.', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    let result = null;
    try {
      if (actionMode === 'edit') {
        result = await updateProduct(data);
      } else {
        result = await addProduct(data);
      }
      navigate(-1);//'/Products'

    } catch (error: any) {
      console.log(error.message);
    }

  };

  //handle image upload
  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
      setUploadStatus("UPLOADING");
    } else {
      setUploadStatus("NO_IMAGE");
    }
  };

  const handleInput = (e: any) => {
    const id = e.target.id;
    const value = e.target.value;

    setData({ ...data, [id]: value });
  };

  const handleMarkAsPaid = async () => {
    if (!id) {
      toast.error('Order ID is missing', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    try {
      await approveOrder(id);
      toast.success('Order approved successfully', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      // Refresh order data
      const order = await getOrder(id);
      if (order) {
        setData((prev: any) => ({
          ...prev,
          ...order,
          orderItems: order.order_items.map((item: any) => ({
            ...item.product,
            price: item.price,
            quantity: item.quantity,
            updated_at: item.updated_at,
          })),
        }));
      }
    } catch (error: any) {
      const message = error.response?.data?.message || error.message || 'Failed to approve order';
      console.error("Error approving order:", message);
      toast.error(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const handleSaveMessage = async () => {
    if (!id) {
      toast.error('Order ID is missing', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    try {
      await updateOrderMessage(id, data?.message || "");
      toast.success('Message saved successfully', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } catch (error: any) {
      console.error("Error saving message:", error?.message);
      toast.error(error?.response?.data?.message || error?.message || 'Failed to save message', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const handleDelete = async () => {
    if (!id) {
      toast.error('Order ID is missing', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    if (!window.confirm('Are you sure you want to delete this order? This action cannot be undone.')) {
      return;
    }

    try {
      await deleteOrder(id);
      toast.success('Order deleted successfully', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      // Navigate back to orders list
      navigate(-1);
    } catch (error: any) {
      console.error("Error deleting order:", error.message);
      toast.error(error?.response?.data?.message || error?.message || 'Failed to delete order', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  // Calculate total items
  const totalItems = data?.orderItems?.reduce((sum: number, item: any) => sum + (item.quantity || 0), 0) || 0;

  return (
    <Layout>
      <HeaderTitle>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          position: 'relative',
          width: '100%'
        }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '8px',
              color: '#5949d1',
              position: 'absolute',
              left: 0,
              borderRadius: '4px',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(89, 73, 209, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
            title="Go back"
          >
            <ArrowBackIcon />
          </button>
          <div style={{ textAlign: 'center' }}>
            {`${actionMode?.toLocaleUpperCase()} ORDER`}
          </div>
        </div>
        <p style={{ textAlign: 'center', marginTop: '8px', fontSize: '16px', fontWeight: 400 }}>
          {`${data?.event?.full_name || ''}`}
        </p>
      </HeaderTitle>
      <Container>
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column',
          width: '100%',
          gap: '20px'
        }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%'
          }}>
            {/* Left side: Total Items first, then Status, Payment Status, etc. */}
            <OrderInfoContainer>
              <OrderInfoItem>
                <OrderInfoLabel>Company</OrderInfoLabel>
                <OrderInfoValueBadge>{data?.company?.name || ''}</OrderInfoValueBadge>
              </OrderInfoItem>
              <OrderInfoItem>
                <OrderInfoLabel>Total Items</OrderInfoLabel>
                <OrderInfoValueBadge>{totalItems}</OrderInfoValueBadge>
              </OrderInfoItem>
              <OrderInfoItem>
                <OrderInfoLabel>Status</OrderInfoLabel>
                <OrderStatusBadge status={data?.status || 'pending'}>
                  {data?.status || 'pending'}
                </OrderStatusBadge>
              </OrderInfoItem>
              <OrderInfoItem>
                <OrderInfoLabel>Payment Status</OrderInfoLabel>
                <OrderStatusBadge status={data?.payment_status === 'succeeded' ? 'approved' : data?.payment_status === 'pending' ? 'pending' : 'failed'}>
                  {data?.payment_status === 'succeeded' ? 'paid' : data?.payment_status || 'unpaid'}
                </OrderStatusBadge>
              </OrderInfoItem>
              <OrderInfoItem>
                <OrderInfoLabel>Payment Attempts</OrderInfoLabel>
                <OrderInfoValueBadge>{data?.transactions_count ?? 0}</OrderInfoValueBadge>
              </OrderInfoItem>
              {(data?.transactions_count ?? 0) > 0 && data?.payment_methods?.length > 0 && (
                <OrderInfoItem>
                  <OrderInfoLabel>Payment method(s)</OrderInfoLabel>
                  <OrderInfoValueBadge>
                    {data.payment_methods.map((m: string) => m === 'bank-transfer' ? 'Bank Transfer' : m.charAt(0).toUpperCase() + m.slice(1)).join(', ')}
                  </OrderInfoValueBadge>
                </OrderInfoItem>
              )}
              {data?.succeeded_payment && (
                <OrderInfoItem>
                  <OrderInfoLabel>Paid via</OrderInfoLabel>
                  <OrderInfoValueBadge>
                    {data.succeeded_payment.method}
                    {data.succeeded_payment.created_at && (
                      <span style={{ fontSize: '13px', fontWeight: 400, color: '#666', marginLeft: '8px' }}>
                        ({new Date(data.succeeded_payment.created_at).toLocaleString()})
                      </span>
                    )}
                  </OrderInfoValueBadge>
                </OrderInfoItem>
              )}
            </OrderInfoContainer>

            {/* Right side: Action Buttons */}
            <OrderActionsContainer>
              <ApproveButton onClick={handleMarkAsPaid}>
                Mark as Paid
              </ApproveButton>
              <DeleteButton onClick={handleDelete}>
                Delete Order
              </DeleteButton>
            </OrderActionsContainer>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            <DataGridWrapper style={{ marginBottom: 0 }}>
              <DataGridContainer>
                <DataGrid
                  style={{ backgroundColor: "white" }}
                  rows={data?.orderItems?.map((item: any) => {
                    return {
                      ...item,
                      currency: data.event?.currency?.toUpperCase(),
                    }
                  })}
                  columns={
                    // productsColumns.concat(actions)
                    productsColumns
                  }
                  pageSize={10}
                  rowsPerPageOptions={[10]}
                // checkboxSelection
                />
              </DataGridContainer>
            </DataGridWrapper>
            {/* <OrderMessageContainer>
              <OrderMessageLabel htmlFor="message">Message for order</OrderMessageLabel>
                <OrderMessageTextArea
                  id="message"
                  placeholder="Enter your message for this order..."
                  value={data?.message || ""}
                  onChange={handleInput}
                />
                <OrderMessageActions>
                  <SaveMessageButton onClick={handleSaveMessage}>
                    Save Message
                  </SaveMessageButton>
                </OrderMessageActions>
              </OrderMessageContainer> */}
            </div>
          </div>
      </Container>
    </Layout>
  );
};

export default NewProduct;
